import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BokkzIbDataService, Aangifte} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-wuo-resultatenrekening',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-wuo-resultatenrekening.component.html',
    styleUrl: './tekst-wuo-resultatenrekening.component.scss',
})
export class TekstWuoResultatenrekeningComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public kmPrijs = 0;
    public drempelZakelijkeKosten = 0
    public maxReisVerblijfkosten = 0
    public percentageKosten = 0
    public verhuiskostenAftrek = 0;

    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year === 2023) {
                this.kmPrijs = 21;
            }
            if (this.year === 2024) {
                this.kmPrijs = 23;
                this.drempelZakelijkeKosten = 5600
                this.maxReisVerblijfkosten = 1500
                this.percentageKosten = 80
                this.verhuiskostenAftrek = 7750
            }
            if (this.year === 2025) {
                this.kmPrijs = 23;
                this.drempelZakelijkeKosten = 5700
                this.maxReisVerblijfkosten = 1500
                this.percentageKosten = 80
                this.verhuiskostenAftrek = 7750
            }
        })
    }

}
